import { classes, style } from 'typestyle';
import { ButtonCircle } from '../../../button-circle';
import { Tooltip } from '../Tooltip';
import { MarkCircle } from '../icons/MarkCircle';
import { colorDarkBlueGrey, colorGreyAccent, colorGunmetal, colorWhite } from '../../../../theme/color';
import { px } from 'csx';
import { Notify } from '../icons/Notify';
import React from 'react';
import { SrOnlyText } from '../SrOnlyText';

interface NotifyButtonProps {
  size?: number;
  notifiedForAvailability?: boolean;
  onClick: () => void;
}

const NotifyButton = ({ size = 40, notifiedForAvailability = false, onClick }: NotifyButtonProps) => {
  return (
    <Tooltip
      positions={['top']}
      content={<span> {notifiedForAvailability ? "We'll keep you posted" : 'Notify me when available'}</span>}
    >
      <ButtonCircle
        className={classes(styles.notifyBtn, notifiedForAvailability && styles.notifySelected)}
        size={size}
        onClick={onClick}
      >
        <Notify />
        {notifiedForAvailability && <MarkCircle className={styles.checkIcon} color={colorGunmetal.toString()} />}
        <SrOnlyText>{notifiedForAvailability ? "We'll keep you posted" : 'Notify me when available'}</SrOnlyText>
      </ButtonCircle>
    </Tooltip>
  );
};

const styles = {
  notifyBtn: style({
    backgroundColor: colorWhite.toString(),
    position: 'relative',
    $nest: {
      '&:hover': {
        backgroundColor: colorDarkBlueGrey.toString(),
      },
    },
  }),
  notifySelected: style({ backgroundColor: colorGreyAccent.toString(), border: 'none' }),
  checkIcon: style({
    position: 'absolute',
    top: px(10),
    right: px(9),
  }),
};

export default NotifyButton;
